import React from 'react';
import DesiredOutcomesSection from './DesiredOutcomesSection/Content';

const DesiredOutcomesSectionPicker = () => {
  return (
    <DesiredOutcomesSection />
  );
};

DesiredOutcomesSectionPicker.propTypes = {
};

export default DesiredOutcomesSectionPicker;
